import React, { useRef, useCallback } from 'react'
import CategoryList from './CategoryList'
import NavigationControls from '../Controls/NavigationControls'
import ScrollControls from '../Controls/ScrollControls'
import { useScrollManagement } from '../hooks'

const GalleryContainer = ({
  processedNavigation,
  navigationLength,
  onThumbClick,
  onEditName,
  onDeleteCategory,
  onEditDocumentName,
  onDeleteDocument,
  onHomeClick,
  onBackClick,
  onBackToTop,
  handleWheel,
  leftArrowRefs,
  rightArrowRefs
}) => {
  const scrollContainerRef = useRef(null)

  const addToLeftRefs = el => {
    if (el && !leftArrowRefs.current.includes(el)) {
      leftArrowRefs.current.push(el)
    }
  }

  const addToRightRefs = el => {
    if (el && !rightArrowRefs.current.includes(el)) {
      rightArrowRefs.current.push(el)
    }
  }

  // Scroll Management Hook
  const { scrollUp, scrollDown, scrollToPosition } = useScrollManagement({
    containerRef: scrollContainerRef,
    enableInfiniteScroll: false,
    enableWheelHandling: true,
    enableContainerFocus: true,
    scrollAmount: 200,
    onWheel: handleWheel
  })

  // Enhanced back to top function that handles both cases
  const handleBackToTopEnhanced = useCallback(() => {
    // Use the scroll management hook for container scrolling
    scrollToPosition(10)

    // Also scroll window as fallback
    window.scrollTo({
      top: 100,
      behavior: 'smooth'
    })

    // Call external callback if provided
    if (onBackToTop) {
      onBackToTop()
    }
  }, [scrollToPosition, onBackToTop])

  return (
    <section className="main-level01" ref={scrollContainerRef}>
      <div className="header-margin"></div>

      <NavigationControls
        onHomeClick={onHomeClick}
        onBackClick={onBackClick}
        onBackToTop={handleBackToTopEnhanced}
      />

      {navigationLength > 0 && (
        <CategoryList
          processedNavigation={processedNavigation}
          onThumbClick={onThumbClick}
          onEditName={onEditName}
          onDeleteCategory={onDeleteCategory}
          onEditDocumentName={onEditDocumentName}
          onDeleteDocument={onDeleteDocument}
          addToLeftRefs={addToLeftRefs}
          addToRightRefs={addToRightRefs}
        />
      )}

      <ScrollControls onScrollUp={scrollUp} onScrollDown={scrollDown} />
    </section>
  )
}

export default GalleryContainer
